<template>
  <div class="feedback-section-wrapper" ref='feedbackWrapper'>
    <div class="second-background">
      <div class="container" v-if="!dataAlreadySended">
        <h2 class="feedback-title h2-title">
          <span>Звʼязатися з нами</span>
        </h2>
        <div class="feedback-text paragraph-s">
          У вас виникли питання чи побажання? Заповніть форму нижче, і ми звʼяжемося з вами найближчим часом.
        </div>
        <div class="feedback-form-wrapper">
          <form class='feedback-form' @submit="submitForm">
            <div class='feedback-form-body'>
              <div class="feedback-form-main">
                <div class='feedback-form-item'>
                  <input v-model="name" type="text" class='app-input app-input-secondary transparent holder-white' placeholder="Імʼя" maxlength="45" required>
                </div>
                <div class='feedback-form-item'>
                  <input v-model="phone" type="tel" class='app-input app-input-secondary transparent holder-white' placeholder="Телефон" maxlength="13" required>
                </div>
                <div class='feedback-form-item'>
                  <input v-model="email" type="email" class='app-input app-input-secondary transparent holder-white' placeholder="Email" maxlength="30" required>
                </div>
              </div>
              <div class="feedback-form-message">
                <textarea v-model="message" name="message" class='app-textarea app-textarea-secondary transparent holder-white' maxlength="355" placeholder="Ваше повідомлення"></textarea>
              </div>
            </div>
            <div class="feedback-form-submit">
              <div class='wait-field fw-bold paragraph-s' v-if="!feedbackFormError">{{waitForResponce}}</div>
              <div class='erorr-field fw-bold paragraph-s' v-if="feedbackFormError">{{feedbackFormError}}</div>
              <button class="app-btn app-btn-primary">Надіслати</button>
            </div>
          </form>
        </div>
      </div>
      <div v-else class='feedback-form-sended'>
        <div class='d-flex flex-column align-items-center'>
          <div class='feedback-form-sended-icon mb-l'>
            <v-icon name='check' scale='4'></v-icon>
          </div>
          <div class='feedback-form-sended-text paragraph-s mb-l'>
            Дякуємо за звернення! Ми звʼяжемося з вами найближчим часом.
          </div>
          <button class='feedback-form-send-again app-btn app-btn-primary' @click="sendFormAgain">
            Надіслати ще раз
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackFormSection',
  data () {
    return {
      feedbackFormError: null,
      waitForResponce: null,
      name: null,
      phone: null,
      email: null,
      message: null,
      dataAlreadySended: false
    }
  },
  methods: {
    sendFormAgain () {
      localStorage.removeItem('feedbackSended')
      this.dataAlreadySended = false
    },
    clearForm () {
      this.name = null
      this.phone = null
      this.email = null
      this.message = null
      this.feedbackFormError = null
      this.waitForResponce = null
    },
    submitForm (event) {
      event.preventDefault()
      this.waitForResponce = 'Надсилаємо повідомлення...'
      const data = {
        name: this.name,
        phone: this.phone,
        email: this.email,
        message: this.message
      }
      this.$store.dispatch('saveCustomerFeedback', data)
        .then(() => {
          localStorage.setItem('feedbackSended', true)
          this.dataAlreadySended = true
          this.clearForm()
        })
        .catch(error => {
          this.waitForResponce = null
          this.feedbackFormError = 'Щось пішло не так. Спробуйте, будь ласка, пізніше.'
          console.error(error)
        })
    }
  },
  mounted () {
    if (localStorage.getItem('feedbackSended')) {
      this.dataAlreadySended = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/_colors.scss";
@import "src/styles/_sizes.scss";

.feedback-section-wrapper {
  background-image: url("/assets/backgrounds/contact-us-bg.jpg");
  background-size: cover;

  .second-background {
    padding: 100px 0px;
    background: $half-black-color;
    color: $white-color;
    display: flex;

    .feedback-form-sended {
      display: flex;
      height: 390px;
      padding: 15px;
      width: 100%;
      justify-content: center;
      align-items: center;
      color: $success-color;
      text-align: center;

      .feedback-form-send-again {
        width: 250px;
      }
    }

    .feedback-title {
      margin-bottom: 20px;
    }

    .feedback-form {
      display: flex;
      flex-direction: column;
      padding-top: 15px;

      .feedback-form-body {
        width: 100%;
        display: flex;

        .feedback-form-main {
          display: flex;
          flex-grow: 1;
          flex-direction: column;
          justify-content: space-between;
          margin-right: 15px;

          .feedback-form-item {
            width: 100%;
            display: flex;
            color: $white-color;
          }
        }

        .feedback-form-message {
          display: flex;
          flex-grow: 1;

          & textarea {
            height: 230px;
            width: 100%;
          }
        }
      }

      .feedback-form-submit {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 15px;

        .wait-field {
          color: $success-color;
        }

        .erorr-field {
          color: $error-color;
        }
      }
    }
  }
}

@media (max-width: $laptop) {
  .feedback-section-wrapper {
    .second-background {
      .feedback-form-sended {
        height: 326px;
      }

      .feedback-form {
        .feedback-form-body {
          .feedback-form-message {
            & textarea {
              height: 180px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: $tablet) {
  .feedback-section-wrapper {
    .second-background {
      padding: 50px 0px;

      .feedback-form-sended {
        height: 300px;
      }

      .feedback-title {
        margin-bottom: 15px;
      }

      .feedback-form {
        .feedback-form-body {
          flex-direction: column;

          .feedback-form-main {
            margin-right: 0;

            .feedback-form-item {
              margin-bottom: 10px;
            }
          }

          .feedback-form-message {
            & textarea {
              height: 180px;
            }
          }
        }

        .feedback-form-submit {
          margin-top: 10px;
          flex-direction: column;

          .erorr-field {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
